import React, { Component }      from 'react';
import Home                      from './components/home/Home';
import SetPassword               from './components/set-password/SetPassword';
import Download                  from './components/download/Download';
import Index                     from './components/Index/Index';

import {
  HashRouter as Router,
  Route,
  Switch,
} from 'react-router-dom'

import './App.scss';

class App extends Component {

  render() {
    return (
      <div className="app__main-app-container" id="app-container">
        <Router>
          <Switch>
            <Route path="/set-password" component={() => <SetPassword />}/>
            <Route path="/recordings/download" component={() => <Download />}/>
            <Route path="/r/:urlKey/recordings/download" component={() => <Download />}/>
            <Route path="/admin" component={() => <Home />}/>
            <Route path="*" component={() => <Index />}/>
          </Switch>
        </Router>
      </div>
    );
  }
}

export default App;